import { PlusCircle } from "../../../../assets/svgIcons";
import EditIconV2 from "../../../../assets/svgIcons/EditIconV2";
import { truncateString } from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";

export const ToolBtn = ({
  bgColor = "transparent",
  color = "#15112D",
  borderColor,
  text = "",
  contentText = null,
  style = {},
  onClick = () => {},
}) => {
  return (
    <primaryComponents.Button
      classNames="btn cover"
      style={{
        background: bgColor,
        // border: "none",
        border: `1px solid ${borderColor ? borderColor : color}`,
        // borderBottom: `1px solid ${borderColor ? borderColor : color}`,
        color: color,
        padding: "0 10px",
        // borderRadius: 0,
        fontSize: "14px",
        // fontWeight: "bold",
        ...style,
      }}
      onClick={onClick}
    >
      <span className="d-flex flex-column w-100" style={{ gap: "5px" }}>
        <span className="d-flex align-items-center justify-content-between w-100">
          <span>{text}</span>
          {contentText ? (
            <EditIconV2 className={"font-weight-normal"} color="#000" />
          ) : (
            <PlusCircle />
          )}
        </span>
        {contentText ? (
          <span
            className="w-100 d-block text-left dark--text"
            style={{
              fontSize: "12px",
              fontWeight: "normal",
            }}
          >
            {truncateString(contentText, 20)}
          </span>
        ) : null}
      </span>
    </primaryComponents.Button>
  );
};
